import { createAsyncTypes } from 'utils/ActionCreator'

import { PLAN_TYPES } from 'containers/App/constants'

const typeKey = 'Partner/EditTenantModal'

export const FETCH_TENANT_DATA = createAsyncTypes('FETCH_TENANT_DATA', typeKey)
export const EDIT_TENANT_APPLY_ASYNC = createAsyncTypes('EDIT_TENANT_APPLY_ASYNC', typeKey)

export const CHANGE_SILENT_MODE_STATUS = `${typeKey}/CHANGE_SILENT_MODE_STATUS`
export const CHANGE_TRIAL_PLAN = `${typeKey}/CHANGE_TRIAL_PLAN`
export const CHANGE_TRIAL_EXPIRATION = `${typeKey}/CHANGE_TRIAL_EXPIRATION`
export const CHANGE_PLAN = `${typeKey}/CHANGE_PLAN`
export const CHANGE_MAILBOX_LIMIT = `${typeKey}/CHANGE_MAILBOX_LIMIT`
export const CHANGE_EXPIRATION_DATE = `${typeKey}/CHANGE_EXPIRATION_DATE`
export const CHANGE_ALLOWED_DOMAINS = `${typeKey}/CHANGE_ALLOWED_DOMAINS`
export const CHANGE_ENFORCE_MAILBOXES_LIMIT = `${typeKey}/CHANGE_ENFORCE_MAILBOXES_LIMIT`
export const CHANGE_DMARC_FOR_PARTNERS = `${typeKey}/CHANGE_DMARC_FOR_PARTNERS`
export const TOGGLE_ADDON = `${typeKey}/TOGGLE_ADDON`
export const TOGGLE_AUTOPILOT = `${typeKey}/TOGGLE_AUTOPILOT`

export const EDIT_TENANT_TABS_OPTIONS = {
  PLANS: 1,
  ACCOUNT_SETTINGS: 2,
}

export const SILENT_MODE_OPTIONS = [
  { value: true, label: 'On' },
  { value: false, label: 'Off' },
]

export const PLAN_OPTIONS = [
  { value: PLAN_TYPES.CAMPAIGNS_ONLY, label: 'Simulation & Training' },
  { value: PLAN_TYPES.SAT_SUITE, label: 'SAT Suite' },
  { value: PLAN_TYPES.CORE, label: 'Essential Protect (Core)' },
  { value: PLAN_TYPES.IRONSCALES_PROTECT, label: 'IRONSCALES Protect' },
  { value: PLAN_TYPES.EMAIL_PROTECT, label: 'Email Protect' },
  { value: PLAN_TYPES.COMPLETE_PROTECT, label: 'Complete Protect' },

]

export const PLAN_TRIAL_OPTIONS = [
  { value: PLAN_TYPES.SAT_SUITE, label: 'SAT Suite' },
  { value: PLAN_TYPES.IRONSCALES_PROTECT, label: 'IRONSCALES Protect' },
  { value: PLAN_TYPES.EMAIL_PROTECT, label: 'Email Protect' },
  { value: PLAN_TYPES.COMPLETE_PROTECT, label: 'Complete Protect' },
]

export const ADD_TO_TRIAL_EXPIRATION_DATE = 14
export const DEFAULT_EXPIRATION_DATE = new Date('2030-12-31')
